import { createSlice } from "@reduxjs/toolkit";

/**
 * confirm 기본 상태 데이터
 * - confirm 모달 초기값
 */
const EMPTY_CONTENT = {
    title: "",
    text: "",
    cancelFunc: null,
    closeFunc: null,
    cancelText: "취소",
    confirmFunc: null,
    confirmText: "",
    textColor: null,
};

/**
 * confirm 전역 상태 초기값
 * - visible : confirm 노출 여부
 * - content : confirm 데이터
 */
const initialState = {
    visible: false,
    content: { ...EMPTY_CONTENT },
};

/**
 * confirm Redux Slice
 * - confirm 모달 상태 및 데이터 관리
 */
const confirmSlice = createSlice({
    name: "confirm",
    initialState,
    reducers: {
        /**
         * confirm 오픈 처리
         * @param {Object} state - 현재 state
         * @param {Object} action - Redux action 객체
         */

        openConfirm(state, action) {
            const config = action.payload || {};
            state.content = {
                text: config.text,
                confirmFunc: config.confirmFunc,
                cancelFunc: config.cancelFunc || null,
                closeFunc: config.closeFunc || null,
                confirmText: config.confirmText,
                cancelText: config.cancelText || null,
                textColor: config.textColor || null,
                title: config.title,
            };
            state.visible = true;
        },

        /**
         * confirm 숨김 처리
         * @param {Object} state - 현재 state
         */

        hideConfirm(state) {
            state.visible = false;
        },

        /**
         * confirm 데이터 초기화
         * @param {Object} state - 현재 state
         */

        resetConfirm(state) {
            state.content = { ...EMPTY_CONTENT };
        },
    },
});

export const { openConfirm, hideConfirm, resetConfirm } = confirmSlice.actions;
export default confirmSlice.reducer;